import React from 'react';  // eslint-disable-line

const Promote = () => {
    return (
        <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="genesis/navbar/icons/promote-hover" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="icon-promote">
                    <path d="M11.4324889,15.546 L12.3445895,17.316 C12.7226312,18.053 12.430599,18.957 11.6935177,19.335 C10.9564364,19.713 10.0523367,19.421 9.67429496,18.684 L7,13.5" id="Shape" stroke="#232323" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M12,7.5 L6.5,7.5 C4.843,7.5 3.5,8.843 3.5,10.5 C3.5,12.157 4.843,13.5 6.5,13.5 L12,13.5 L18.5,16.5 L18.5,4.5 L12,7.5 Z" id="Shape" stroke="#232323" strokeLinecap="round" strokeLinejoin="round" />
                </g>
            </g>
        </svg>
    );
};

export default Promote;
